export default "__VITE_ASSET__DPsI2EdP__"